import { render } from "./recapTransfere.vue?vue&type=template&id=5e94a2d4&scoped=true"
import script from "./recapTransfere.vue?vue&type=script&lang=js"
export * from "./recapTransfere.vue?vue&type=script&lang=js"

import "./recapTransfere.vue?vue&type=style&index=0&id=5e94a2d4&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e94a2d4"]])

export default __exports__